import { HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCashAdvanceSlideout extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelCashAdvanceHistory: Label;
    layoutCashAdvanceHistory: Layout;
    panelDriverFuelCardPanel1: Panel;
    panelDriverFuelCardPanel2: Panel;
    panelDriverFuelCardPanel3: Panel;
    panelDriverFuelCardPanel4: Panel;
    textboxAmount: Textbox;
    textboxAmountAvailable: Textbox;
    textboxCardNum: Textbox;
    textboxCash: Textbox;
    textboxCashUsed: Textbox;
    textboxContractLimit: Textbox;
    textboxDriverName: Textbox;
    textboxHistoryDateRange: Textbox;
    textboxNotes: Textbox;
    textboxOneTimeCash: Textbox;
    textboxOneTimeLimit: Textbox;
    textboxPolicyCardCash: Textbox;
    textboxTotalAvailable: Textbox;
    textboxTotalCash: Textbox;
    textboxVendor: Textbox;
}
